import { useState } from "react";
import { motion } from "framer-motion";
import { Input } from "@/components/ui/input";
import { submitLead } from "@/lib/api";
import { BLOG } from "@/constants/testIds";

const BlogNewsletter = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) {
      setError("Enter a valid email");
      return;
    }
    setError("");
    try {
      await submitLead({ email, source: "blog_newsletter" });
      setSubmitted(true);
    } catch {
      setError("Something went wrong. Try again.");
    }
  };

  return (
    <div data-testid={BLOG.newsletterSection} className="glass-panel rounded-2xl p-8 sm:p-10 text-center mt-16">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#7C93B8] mb-3">Daily Growth Tips</p>
      <h3 className="font-display text-2xl font-bold tracking-tight mb-6 max-w-md mx-auto">
        Get one sharp growth tactic in your inbox, every day.
      </h3>

      {submitted ? (
        <motion.p
          data-testid={BLOG.newsletterSuccessMsg}
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="text-white font-semibold"
        >
          You're subscribed. Watch your inbox.
        </motion.p>
      ) : (
        <form onSubmit={handleSubmit} noValidate className="flex flex-col sm:flex-row gap-2 max-w-md mx-auto">
          <Input
            data-testid={BLOG.newsletterEmailInput}
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@yourapp.com"
            className="bg-white/5 border-white/10 text-white placeholder:text-white/30 h-11 flex-1"
          />
          <button
            data-testid={BLOG.newsletterSubmitBtn}
            type="submit"
            className="rounded-full bg-[#2563EB] text-white font-semibold px-6 py-3 text-sm hover:bg-[#3B82F6] transition-colors duration-300 whitespace-nowrap"
          >
            Subscribe
          </button>
        </form>
      )}
      {error && <p className="text-sm text-red-400 mt-3">{error}</p>}
    </div>
  );
};

export default BlogNewsletter;
